import { Button } from "@/components/ui/button";
import { useT } from "../lib/useLanguage";

export default function EmptyState({ onReset, onCreateRequest }) {
  const t = useT();
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-6">
      <div className="w-16 h-16 rounded-2xl mb-4 flex items-center justify-center text-3xl"
        style={{ backgroundColor: "#FFF4E8", border: "2px dashed #FF6B4A" }}>
        ✦
      </div>
      <h3 className="text-lg font-bold text-foreground mb-1">{t("discover_empty")}</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-xs">{t("discover_empty_sub")}</p>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" className="rounded-full" onClick={onReset}>
          {t("discover_restart")}
        </Button>
        <Button size="sm" className="rounded-full" style={{ backgroundColor: "#FF6B4A" }} onClick={onCreateRequest}>
          {t("discover_empty_cta")}
        </Button>
      </div>
    </div>
  );
}